'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iaReact = require('ia.react.iconlist');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
	var IconPath = [];

	var isNameExist = Object.keys(_iaReact.ICONS).filter(function (name) {
		return name === props.icon;
	}).length > 0;

	if (isNameExist) {
		if (_iaReact.ICONS[props.icon].length > 0) {
			_iaReact.ICONS[props.icon].forEach(function (element, i) {
				IconPath.push(_react2.default.createElement('path', { key: i, style: { fill: props.color }, d: _iaReact.ICONS[props.icon][i] }));
			});
		}
	} else {
		var nameList = [];

		Object.keys(_iaReact.ICONS).filter(function (name) {
			nameList.push('\n' + name);
		});

		console.warn('This icon name "' + props.icon + '" does not exist on this module of ia.react.iconlist, make sure you are on the latest version available. \n try running "npm i ia.react.iconlist -s" \n Git: http://10.1.198.80:4873/#/detail/ia.react.iconlist \n\n[Available icons]\n' + nameList);
	}
	return _react2.default.createElement(
		'svg',
		{ style: _extends({ display: 'inline-block', verticalAlign: 'middle' }, props.style), width: props.size + 'px', height: props.size + 'px', viewBox: '0 0 1024 1024' },
		IconPath
	);
};

Icon.propTypes = {
	icon: _propTypes2.default.string.isRequired,
	size: _propTypes2.default.number,
	color: _propTypes2.default.string
};

Icon.defaultProps = { size: 16 };

exports.default = Icon;